var _path, _path2, _path3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDuoList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    transform: "rotate(0 0 0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 3.75H6.83C7.7965 3.75 8.58 4.5335 8.58 5.5V6.83C8.58 7.7965 7.7965 8.58 6.83 8.58H5.5C4.5335 8.58 3.75 7.7965 3.75 6.83V5.5C3.75 4.5335 4.5335 3.75 5.5 3.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 10.0801C4.5335 10.0801 3.75 10.8636 3.75 11.8301V13.1601C3.75 14.1266 4.5335 14.9101 5.5 14.9101H6.83C7.7965 14.9101 8.58 14.1266 8.58 13.1601V11.8301C8.58 10.8636 7.7965 10.0801 6.83 10.0801H5.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 18.1602C3.75 17.1937 4.5335 16.4102 5.5 16.4102H6.83C7.7965 16.4102 8.58 17.1937 8.58 18.1602V19.4902C8.58 20.4567 7.7965 21.2402 6.83 21.2402H5.5C4.5335 21.2402 3.75 20.4567 3.75 19.4902V18.1602Z",
    fill: "currentColor"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8301 5.41406C10.4159 5.41406 10.0801 5.74985 10.0801 6.16406C10.0801 6.57828 10.4159 6.91406 10.8301 6.91406H20.5C20.9142 6.91406 21.25 6.57828 21.25 6.16406C21.25 5.74985 20.9142 5.41406 20.5 5.41406H10.8301Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0801 12.4941C10.0801 12.0799 10.4159 11.7441 10.8301 11.7441H20.5C20.9142 11.7441 21.25 12.0799 21.25 12.4941C21.25 12.9084 20.9142 13.2441 20.5 13.2441H10.8301C10.4159 13.2441 10.0801 12.9084 10.0801 12.4941Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8301 18.0742C10.4159 18.0742 10.0801 18.41 10.0801 18.8242C10.0801 19.2384 10.4159 19.5742 10.8301 19.5742H20.5C20.9142 19.5742 21.25 19.2384 21.25 18.8242C21.25 18.41 20.9142 18.0742 20.5 18.0742H10.8301Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuoList);
export default __webpack_public_path__ + "static/media/DuoList.1fa53c339c9a32f20b4e31b0d6dce0d5.svg";
export { ForwardRef as ReactComponent };